import { DownloadIcon } from '@radix-ui/react-icons'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'

const DISMISSED_KEY = 'hfk-install-dismissed'

interface BeforeInstallPromptEvent extends Event {
	prompt: () => Promise<void>
	userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

export function InstallAppMenuItem() {
	const [visible, setVisible] = useState(false)
	const [installPrompt, setInstallPrompt] =
		useState<BeforeInstallPromptEvent | null>(null)

	useEffect(() => {
		const isStandalone =
			window.matchMedia('(display-mode: standalone)').matches ||
			(window.navigator as Navigator & { standalone?: boolean }).standalone ===
				true
		try {
			if (isStandalone || localStorage.getItem(DISMISSED_KEY) === 'true') {
				return
			}
		} catch {
			// localStorage may be unavailable (private mode, etc.)
		}

		const onPrompt = (event: Event) => {
			event.preventDefault()
			setInstallPrompt(event as BeforeInstallPromptEvent)
			setVisible(true)
		}
		window.addEventListener('beforeinstallprompt', onPrompt)

		// iOS Safari has no install prompt, but can still add to home screen
		if (
			installPrompt === null &&
			/iphone|ipad|ipod/i.test(navigator.userAgent)
		) {
			setVisible(true)
		}

		return () => window.removeEventListener('beforeinstallprompt', onPrompt)
	}, [installPrompt])

	if (!visible) return null

	const showInstructions = () => {
		toast('Legg til på heimeskjermen', {
			description:
				'Trykk på Del-knappen i nettlesaren og vel «Legg til på Hjem-skjermen». Då får du billettane og programmet òg utan nett.',
			duration: 10_000,
		})
	}

	return (
		<button
			type="button"
			className="pb-2 pt-2"
			onClick={() => {
				if (installPrompt) {
					void installPrompt.prompt()
				} else {
					showInstructions()
				}
			}}
		>
			<DownloadIcon className="mr-2 inline h-4 w-4" />
			Installer appen
		</button>
	)
}
